import constants from '../constants';

const getParentGlobalElement = (childElement) =>
  childElement.parentElement.closest(constants.GLOBAL_TAG_NAME);

export default getParentGlobalElement;
